// extracted by mini-css-extract-plugin
module.exports = {"contenedor":"LightweightChart__contenedor__5qtpk"};